// extracted by css-extract-rspack-plugin
export default {"checked":"checked-T06P1F","checkDot":"checkDot-Gzid6x","checkMark":"checkMark-CSzdF2","empty":"empty-v899kS"};